$ = jQuery;

$(document).ready(function($) {
    if($('.gallery-widget').length > 0) {

        $('.gallery-widget').map(function(key, slider) {
            //Gallery
                var sliderid = slider.dataset.sliderid;
                slider = new Swiper ('[data-sliderid="' + sliderid + '"] .gallery-slider', {
                    slidesPerView: 1,
                    centeredSlides: true,
                    loop: true,
                    loopedSlides: 6,
                    navigation: {
                        nextEl: '[data-sliderid="' + sliderid + '"] .swiper-button-next',
                        prevEl: '[data-sliderid="' + sliderid + '"] .swiper-button-prev'
                    }
                });

                var thumbs = new Swiper ('.gallery-thumbs', {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                    centeredSlides: true,
                    loop: true,
                    slideToClickedSlide: true,
                });


                slider.controller.control = thumbs;
                thumbs.controller.control = slider;


            Fancybox.bind('[data-sliderid="' + sliderid + '"] a.swiper-slide:not(.swiper-slide-duplicate)', {
                thumbs   : true,
                hash     : false,
                animationEffect : "fade",
                groupAll : true, // Group all items
            });

        });
    }

});